/**
 * `BankingSection` - provider + masked bank-detail fields.
 *
 * `bank_account_number`, `sort_code`, `iban`, and `tribe_epm_id` are all
 * PII per `06-data-design.md` Section 1 and so route through MaskedField.
 * `provider` is non-PII (it is the issuer-processor name, e.g. Tribe /
 * EPS) and is rendered verbatim.
 */
import type { Account, BffClient } from '../../../lib/bff-client'
import { MaskedField } from '../../../components/masked-field'
import { Field, FieldValue, Section } from './section'

export interface BankingSectionProps {
  readonly account: Account
  readonly client: BffClient
  readonly onAuthError?: ((err: unknown) => void) | undefined
}

export function BankingSection({ account, client, onAuthError }: BankingSectionProps): JSX.Element {
  return (
    <Section title="Banking">
      <Field label="Provider">
        <FieldValue value={account.provider} />
      </Field>
      <Field label="Bank account number">
        <MaskedField
          client={client}
          accountId={account.id}
          field="bank_account_number"
          value={account.bank_account_number}
          label="bank account number"
          onAuthError={onAuthError}
        />
      </Field>
      <Field label="Sort code">
        <MaskedField
          client={client}
          accountId={account.id}
          field="sort_code"
          value={account.sort_code}
          label="sort code"
          onAuthError={onAuthError}
        />
      </Field>
      <Field label="IBAN">
        <MaskedField
          client={client}
          accountId={account.id}
          field="iban"
          value={account.iban}
          label="IBAN"
          onAuthError={onAuthError}
        />
      </Field>
      <Field label="Tribe EPM id">
        <MaskedField
          client={client}
          accountId={account.id}
          field="tribe_epm_id"
          value={account.tribe_epm_id}
          label="Tribe EPM id"
          onAuthError={onAuthError}
        />
      </Field>
    </Section>
  )
}
